import { API } from '../api/API';
import useAuthStore from '../store/authStore';

/**
 * @typedef {Object} ConsultationReception
 * @property {number} id - ID auto-généré de la relation
 * @property {number} consultation_id - ID de la consultation
 * @property {number} reception_id - ID de la réception
 * @property {number} medecin_clinique_id - ID du médecin de la clinique
 * @property {number} medecin_clinique_labo_id - ID du médecin du laboratoire
 */

const consultationReceptionService = {
// Récupérer toutes les relations consultation-réception
  getAllConsultationReceptions: async (page = 1, limit = 10, filters = {}) => {
    try {
      const store = useAuthStore.getState();
      const params = {
        page,
        limit,
        ...filters,
        structure_id: store.user?.partie_id
      };
      
      const response = await API.get('/consultation-receptions', { params });
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      throw {
        success: false,
        message: error.response?.data?.error || 'Erreur lors de la récupération des relations',
        details: error.response?.data?.details
      };
    }
  },

  // Créer une nouvelle relation consultation-réception
  createConsultationReception: async (consultationReceptionData) => {
    try {
      const store = useAuthStore.getState();
      const data = {
        ...consultationReceptionData,
        structure_id: store.user?.partie_id
      };
      
      const response = await API.post('/consultation-receptions', data);
      return {
        success: true,
        data: response.data,
        message: 'Relation consultation-réception créée avec succès'
      };
    } catch (error) {
      throw {
        success: false,
        message: error.response?.data?.error || 'Erreur lors de la création de la relation',
        details: error.response?.data?.details
      };
    }
  },

  // Supprimer une relation consultation-réception
  deleteConsultationReception: async (id) => {
    try {
      await API.delete(`/consultation-receptions/${id}`);
      return {
        success: true,
        message: 'Relation consultation-réception supprimée avec succès'
      };
    } catch (error) {
      throw {
        success: false,
        message: error.response?.data?.error || 'Erreur lors de la suppression de la relation',
        details: error.response?.data?.details
      };
    }
  }
};

export default consultationReceptionService; 